import * as React from 'react';
import { memo } from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgOverview = function SvgOverview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 16v128c-35.299 0-64-28.701-64-64s28.591-64 64-64Z",
    fill: "#E6F0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130 40H29v79.043h101V40Z",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.217 53.174H37.783v13.174h83.434V53.174ZM46.565 79.522h26.348M42.174 88.304h30.739M42.174 97.087h30.739M42.174 105.87h30.739M86.087 79.522h30.739M86.087 88.304h30.739M86.087 97.087h30.739M86.087 105.87h26.348",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var Memo = /*#__PURE__*/memo(SvgOverview);

export { Memo as default };
//# sourceMappingURL=overview.svg.js.map
